<div class="appContentsContainer">
  <form class="formGroup container halfForm wrapHalfRows" *ngIf="placa?.loaded">
    <div class="pageTitle">Datos generales</div>

    <div class="halfGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.peticion"
            class="submitSearchButton"
            (click)="sectionHidden.peticion = !sectionHidden.peticion"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.peticion"
            class="submitSearchButton"
            (click)="sectionHidden.peticion = !sectionHidden.peticion"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Datos de solicitud</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.peticion">
        <app-form-fields 
        #solicitud
        *ngIf="fieldsSolicitud"
        [fields]="fieldsSolicitud"></app-form-fields>
        <div class="consultaEditarButtonGroup marginButtonPrecio reponsiveWidth" *ngIf="this.isPrecioEdit()">
          <div class="buttonContainer justifyButtonPrecio">
            <div class="buttonPrecio">
              <div class="middleButtonAceptar mr-1">
                <button class="formButton" type="button" (click)="onSavePrecio()">
                  {{ "commons.save" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="halfGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.vehiculo"
            class="submitSearchButton"
            (click)="sectionHidden.vehiculo = !sectionHidden.vehiculo"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.vehiculo"
            class="submitSearchButton"
            (click)="sectionHidden.vehiculo = !sectionHidden.vehiculo"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Datos de vehículo</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.vehiculo">
        <app-form-fields #vehiculo [fields]="fieldsVehiculo"></app-form-fields>
      </div>
    </div>

    <div class="fullGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.obs"
            class="submitSearchButton"
            (click)="sectionHidden.obs = !sectionHidden.obs"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.obs"
            class="submitSearchButton"
            (click)="sectionHidden.obs = !sectionHidden.obs"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Comentario / Observaciones</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.obs" class="reponsiveWidthComentarios">
        <app-form-fields
          #comentario
          [fields]="fieldsComentario"
        ></app-form-fields>
      </div>
    </div>

    <div class="fullGroup">
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.correction"
            class="submitSearchButton"
            (click)="sectionHidden.correction = !sectionHidden.correction"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.correction"
            class="submitSearchButton"
            (click)="sectionHidden.correction = !sectionHidden.correction"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Datos concretos</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.correction">
        <app-dynamic-fields
          #dynamicFields
          *ngIf="placa && placa.data && placa.data.peticion"
          [fields]="fieldsCasted"
          [operation]="operation"
          (downloadFileEvent)="downloadFile($event)"
        ></app-dynamic-fields>
      </div>
    </div>

    <div
      class="consultaEditarButtonGroup reponsiveWidth"
      *ngIf="
        placa &&
        placa.data &&
        placa.data.peticion &&
        ((operation == 'detail' &&
          placa.data.peticion.estado.esId == 'PC' &&
          (placa.data.peticion.usuario1.usId == userIdConected ||
            placa.data.peticion.usuario2.usId == userIdConected)) ||
          operation == 'edit')
      "
    >
      <div class="buttonContainer">
        <div class="middleButtonAceptar mr-1">
          <button
            class="formButton"
            type="button"
            (click)="onCorrect()"
            *ngIf="operation == 'edit'"
          >
            {{ "commons.ok" | translate }}
          </button>

          <button
            class="formButton"
            type="button"
            *ngIf="
              operation == 'detail' &&
              placa.data.peticion.estado.esId == 'PC' &&
              (placa.data.peticion.usuario1.usId == userIdConected ||
                placa.data.peticion.usuario2.usId == userIdConected)
            "
            (click)="goEdit()"
          >
            {{ "commons.correct" | translate }}
          </button>
        </div>

        <div class="middleButtonAceptar">
          <button
            class="formButton"
            type="button"
            *ngIf="operation == 'edit'"
            (click)="goDetail()"
          >
            {{ "commons.cancel" | translate }}
          </button>
        </div>
      </div>
    </div>

    <div
      class="fullGroup"
      *appPermsRoles="[
        roles.ADMIN,
        roles.ANALISTA,
        roles.RHOMOLOG,
        roles.IMPORT,
        roles.REVISOR,
        roles.ABASICO,
        roles.AAVANZA,
        roles.TECNICO
      ]"
    >
      <div class="collapsibleTitle pageTitle">
        <div class="collapseButtonContainer">
          <button
            type="button"
            *ngIf="!sectionHidden.placa"
            class="submitSearchButton"
            (click)="sectionHidden.placa = !sectionHidden.placa"
          >
            <em class="fas fa-angle-up"></em>
          </button>

          <button
            type="button"
            *ngIf="sectionHidden.placa"
            class="submitSearchButton"
            (click)="sectionHidden.placa = !sectionHidden.placa"
          >
            <em class="fas fa-angle-down"></em>
          </button>

          <div class="pageTitle collapsibleTitle">
            <div class="title halfTitle">Datos de placa</div>
          </div>
        </div>
      </div>

      <div *ngIf="!sectionHidden.placa" class="reponsiveWidthComentarios">
        <div class="row compressedRow">
          <div class="itemContainer col">
            <div
              class="seachLabel inputLabelContainer labelContainerPlacaData fontSize"
            >
              <div class="inputLabel"><label>Tipo etiqueta</label></div>
            </div>

            <div class="inputContainer">
              <div class="labelAsInput">
                <label>
                  <select
                    [(ngModel)]="etiquetaSelected"
                    name="etiqueta"
                    [disabled]="!isPosibleChangeData()"
                  >
                    <option value="0">Selecciona una opción</option>

                    <option
                      [ngValue]="etiqueta.tpTipo"
                      *ngFor="let etiqueta of etiquetas"
                    >
                      {{ etiqueta.tpNombre }}
                    </option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>

        <form
          [formGroup]="placaData"
          (ngSubmit)="onSave()"
          *ngIf="formLoaded"
          (keydown)="preventEnter($event)"
        >
          <div *ngFor="let field of fields.list" class="wrapper">
            <div class="row compressedRow">
              <div class="itemContainer col">
                <div
                  class="seachLabel inputLabelContainer labelContainerPlacaData fontSize"
                >
                  <div class="inputLabel">
                    <label>{{ field.ciDesc }}</label>
                  </div>
                </div>

                <div class="inputContainer">
                  <input
                    id="field.ciId"
                    type="text"
                    formControlName="{{ field.ciId }}"
                    (keydown)="preventEnter($event)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="row compressedRow mt-2">
              <div class="itemContainer col">
                <div class="seachLabel inputLabelContainer fontSize">
                  <div class="inputLabel">
                    <label>Código de imagen placa</label>
                  </div>
                </div>

                <div class="inputContainer">
                  <input
                    id="NewImagePlaca"
                    [(ngModel)]="this.imgPlaca.codImagenNueva"
                    [ngModelOptions]="{ standalone: true }"
                    type="text"
                    (keydown)="preventEnter($event)"
                    [readOnly]="!isPosibleChangeData()"
                  />

                  <ng-container *ngIf="isPosibleChangeData()">
                    <button
                      type="button"
                      class="buttonImagePlaca"
                      (click)="asingImgPlaca()"
                    >
                      <em class="fas fa-upload"></em>
                    </button>

                    <button
                      type="button"
                      class="buttonImagePlaca"
                      (click)="getHisoricoBastidor()"
                    >
                      <em class="fas fa-level-down-alt"></em>
                    </button>

                    <button
                      class="buttonImagePlaca"
                      type="button"
                      (click)="createImgPlaca()"
                    >
                      <em class="fas fa-plus-square"></em>
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div
            class="consultaEditarButtonGroup reponsiveWidth"
            *ngIf="
              placa &&
              placa.data &&
              placa.data.peticion &&
              isPosibleChangeData()
            "
          >
            <div class="buttonContainer">
              <div class="middleButtonAceptar mr-1">
                <button class="formButton" type="button" (click)="refresh()">
                  {{ "commons.update" | translate }}
                </button>
              </div>

              <div class="middleButtonAceptar">
                <button class="formButton" type="submit">
                  {{ "commons.ok" | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="fullGroup" *ngIf="placa.data.peticion">
      <div style="margin-bottom: 5px">
        <app-comments-history-peticion [id]="id">
        </app-comments-history-peticion>
      </div>
    </div>

    <div class="fullGroup" *ngIf="placa.data.peticion">
      <div style="margin-bottom: 5px">
        <app-compare-release-peticion
          [type]="'Placa'"
          [id]="id"
          [fields]="fields.list"
          [isHistoric]="this.type == 'history'"
        ></app-compare-release-peticion>
      </div>
    </div>

    <div class="fullGroup" *ngIf="placa && placa.data && placa.data.peticion">
      <div style="margin-bottom: 5px">
        <app-list-related-requests
          [config]="config"
        ></app-list-related-requests>
      </div>
    </div>

    <div
      class="fullGroup"
      *ngIf="
        placa &&
        placa.data &&
        placa.data.peticion &&
        placa.data.peticion.estado.esId == 'AN'
      "
    >
      <div style="margin-bottom: 5px">
        <app-reasigne-analyst
          [idPetition]="id"
          [analyst]="placa.data.peticion.usuario2.usNombre"
          [peRelease]="placa.data.peticion.id.peRelease"
          (reasgine)="reasgine($event)"
        ></app-reasigne-analyst>
      </div>
    </div>

    <div class="consultaEditarButtonGroup">
      <div class="backButton">
        <button class="formButton" type="button" (click)="goList()">
          <em class="fas fa-chevron-left"></em>
        </button>
      </div>
    </div>
  </form>
</div>

<app-states
  #states
  *ngIf="placa && placa.data && placa.data.peticion && placa.loaded"
  [actualState]="placa.data.peticion.estado.esId"
  [idPetition]="id"
  [release]="placa.data.peticion.id.peRelease"
  (reloadPetition)="reloadDetail($event)"
></app-states>
